<div class="forbidden-container">
    <div class="forbidden-card">
      <!-- Header -->
      <div class="card-header">
        <div class="icon-container">
          <i class="fas fa-shield-alt"></i>
        </div>
        <h1>Acceso Denegado</h1>
        <p>No tienes permisos suficientes para acceder. Contacta con soporte e indique sus necesidades para que te asignen los permisos necesarios.</p>
      </div>
  
      <!-- Content -->
      <div class="card-content">
        <div class="contact-box">
          <h2>Contacta con Soporte APSER</h2>
          <div class="contact-info">
            <a [href]="'mailto:' + contactInfo.email" class="contact-link">
              <i class="fas fa-envelope"></i>
              {{contactInfo.email}}
            </a>
          </div>
        </div>
        <p class="help-text">
          Para obtener acceso, por favor contacta con nuestro equipo de soporte y proporciona tus credenciales.
        </p>
      </div>
  
      <!-- Footer -->
      <div class="card-footer">
        <button (click)="login()" class="home-button">
          <i class="fas fa-home"></i>
          Iniciar sesión
        </button>
      </div>
    </div>
  </div>